import { render, staticRenderFns } from "./AuctionIndex.vue?vue&type=template&id=0fd22980"
import script from "./AuctionIndex.vue?vue&type=script&lang=js"
export * from "./AuctionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports